import { useNavigation } from '@atom/hooks/useNavigation';

import classes from './mapDrawerContent.module.css';

interface Props {
  label: string;
  navigateUrl?: string;
}

const NavigationButton = ({ label, navigateUrl }: Props) => {
  const [, { Link }] = useNavigation();
  return (
    <Link to={navigateUrl}>
      <div className={classes.summaryButton}>{label}</div>
    </Link>
  );
};

export default NavigationButton;
